module.exports = __webpack_public_path__ + "static/media/zelte.5b5f3390.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zelte.jpg
// module id = 114
// module chunks = 0